import { useEffect } from 'react'

export default function DocumentTitle({ title }) {
    useEffect(() => {
        document.title = title
        return () => {
            document.title = 'BO - Baltic Watches'
        }
    }, [title])

    return null
}
